// signup

export const SIGNUPREQUEST="SIGNUPREQUEST"
export const SIGNUPSUCESS="SIGNUPSUCESS"
export const SIGNUPFAIL="SIGNUPFAIL"
export const BACKFROMSIGNUPFAIL="BACKFROMSIGNUPFAIL"

// login

export const LOGINEQUEST="LOGINREQUEST"
export const LOGINSUCESS="LOGINSUCESS"
export const LOGINFAIL="LOGINFAIL"
export const BACKFROMLOGINFAIL="BACKFROMLOGINFAIL"

// logout

export const LOGOUTSUCESSFUL="LOGOUTSUCESSFUL"